import React from 'react';
import Contact from '../components/ContactComponent';

const ContactContainer = React.createClass({
  componentDidMount() {
    const body = document.getElementsByTagName('body')[0];
    document.title = 'Nathan Kleekamp | Contact';
    body.className = 'default';
    this.setMetaDescription();
  },


  setMetaDescription() {
    const desc = document.querySelectorAll('meta[name=description');
    desc[0].content = 'I am currently accepting projects. Contact me on one of these social media platforms.';
  },


  render() {
    return (
      <Contact />
    );
  }
});

export default ContactContainer;



// WEBPACK FOOTER //
// ./app/src/Contact/containers/ContactContainer.js